import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/upload/upload.png'


const _hoisted_1 = { class: "insurance-questionnaire" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-6" }, "工种核保信息填写", -1)
const _hoisted_4 = { class: "video-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "percentage-value" }
const _hoisted_7 = { class: "percentage-label" }
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"20px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 增加一个 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 最多可以上传3个 ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 拍摄实际操作的近景工作视频 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 视频时间10-60S，视频大小不超过20M ", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_24 = { class: "form-row mt-6" }
const _hoisted_25 = {
  key: 1,
  class: "success-screen"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-6" }, "提交成功！", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "感谢您的提交，我们会尽快处理", -1)

import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { fileUpload } from '@/api/base'
import { ElUploadRequestOptions } from 'element-plus/lib/components/upload/src/upload.type'
import { getOccupationList, getSupplierList, supplierDto, occupationDto, send } from '@/api/questionnaire'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const files = ref<Array<{ name: string; url: string; preview: string; id: string }>>([])
const uploading = ref(false)

// 表单数据模型
const form = reactive({
    clientName: '',
    companyName: '',
    occupationTips: '',
    workVideo: [], // 存储上传的视频文件
    supplier: [],
    occupation: [],
    involveHeight: '0', // 新增涉高字段
    involveLoading: '0',
    involveMachine: '0'
})

const rules = {
    clientName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
    companyName: [{ required: true, message: '请输入被派遣单位名称', trigger: 'blur' }],
    occupationTips: [{ required: true, message: '请描述岗位工种', trigger: 'blur' }],
    workVideo: [{ required: true, message: '请上传工种视频', trigger: 'change' }],
    occupation: [{ required: true, message: '请选择工种', trigger: 'change' }],
    involveHeight: [{ required: true, message: '请选择是否涉高', trigger: 'change' }], // 新增涉高验证
    involveLoading: [{ required: true, message: '请选择是否涉及装运、搬卸', trigger: 'change' }],
    involveMachine: [{ required: true, message: '请选择是否涉及机器操作', trigger: 'change' }]
}

const supplierList = ref<supplierDto[]>([])
const occupationList = ref<occupationDto[]>([])

const percentage = ref('' | 0)
const progressStatus = ref('' | 'success' | 'exception' | 'warning')

const isSubmitting = ref(false) // 控制按钮禁用状态
const isSuccess = ref(false) // 控制成功界面显示

// 上传视频前预处理
const beforeVideo = (file: File): false | undefined => {
    if (file.size / 1024 / 1024 > 20) {
        ElMessage.error('请限制视频大小在20M以内')
        uploading.value = false
        return false
    }
}

// 上传视频
const handleFileUpload = async (file: ElUploadRequestOptions) => {
    const formData = new FormData()
    formData.append('iFile', file.file)
    const data = await fileUpload(formData, {
        isLoading: false,
        onUploadProgress: (progressEvent: any) => {
            const num = ((progressEvent.loaded / progressEvent.total) * 100) | 0 // 百分比
            file.onProgress({ percent: num } as ProgressEvent) // 更新进度条
            percentage.value = num
            if (num === 100) {
                file.onSuccess('arraybuffer')
                progressStatus.value = 'success'
            }
        }
    })
    percentage.value = 0
    form.workVideo.push({
        name: data.fileInfo.file_name,
        url: data.fileInfo.external_url,
        preview: data.fileInfo.preview_url,
        id: data.fileInfo.file_id
    })
}

const fileRemove = (index: number) => {
    this.from.workVideo.splice(index, 1)
}

const getSupplier = async () => {
    const result = await getSupplierList()
    supplierList.value = result
    console.log(supplierList)
}

const getOccupation = async () => {
    const result = await getOccupationList()
    occupationList.value = result
    console.log(occupationList)
}

// 表单引用（用于表单验证等操作）
const formRef = ref(null)

const submitForm = async () => {
    if (isSubmitting.value) return // 避免重复提交
    isSubmitting.value = true
    try {
    // 模拟提交逻辑
        console.log('提交表单数据:', form)
        await formRef.value.validate().then(() => {
            console.log('表单验证通过，提交数据:', form)
            send(form).then(response => {
                isSuccess.value = true // 显示成功界面
                console.log('提交成功', response)
            }).catch(error => {
                console.error('提交错误:', error)
            })
        }).catch(() => {
            ElMessage.error('请检查您的表单内容')
        })
    } catch (error) {
        console.error('提交失败', error)
    } finally {
        isSubmitting.value = false
    }
}

const goBack = () => {
    window.location.reload()
}

getSupplier()
getOccupation()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_form, {
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            model: _unref(form),
            rules: rules,
            "label-width": "100%",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "1. 请输入您的公司名称",
                prop: "clientName",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).clientName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).clientName) = $event)),
                    placeholder: "请输入公司名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "2. 请输入被派遣单位名称（全称）",
                prop: "companyName",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).companyName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).companyName) = $event)),
                    placeholder: "请输入被派遣单位全称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "3. 请详细描述岗位工种（包括工作内容、生产成品、工作环境等）",
                prop: "occupationTips",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    modelValue: _unref(form).occupationTips,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).occupationTips) = $event)),
                    placeholder: "请详细描述岗位工种",
                    rows: "4"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "4. 请上传被派遣单位工种视频",
                prop: "workVideo",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).workVideo, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "video-item",
                        key: index
                      }, [
                        _createVNode(_component_el_image, {
                          fit: "cover",
                          class: "video-cover",
                          src: item.preview
                        }, null, 8, ["src"]),
                        _createElementVNode("i", {
                          class: "delete el-icon el-icon-circle-close",
                          onClick: ($event: any) => (fileRemove(index))
                        }, null, 8, _hoisted_5)
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_el_upload, {
                    class: "upload",
                    drag: "",
                    name: "iFile",
                    multiple: "",
                    "show-file-list": false,
                    accept: "video/*",
                    "http-request": handleFileUpload,
                    "before-upload": beforeVideo,
                    onChange: _cache[3] || (_cache[3] = () => {uploading.value = !uploading.value})
                  }, {
                    default: _withCtx(() => [
                      (percentage.value)
                        ? (_openBlock(), _createBlock(_component_el_progress, {
                            key: 0,
                            type: "dashboard",
                            percentage: percentage.value,
                            status: progressStatus.value
                          }, {
                            default: _withCtx((data) => [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(data.percentage) + "%", 1),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(progressStatus.value === 'success' ? '保存中' : '文件上传中'), 1)
                            ]),
                            _: 1
                          }, 8, ["percentage", "status"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _hoisted_9,
                            (files.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "5. 是否涉高（距离基准面在2米及2米以上）?",
                prop: "involveHeight",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(form).involveHeight,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).involveHeight) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "1" }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "0" }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "6. 是否涉及装运、搬卸?",
                prop: "involveLoading",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(form).involveLoading,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).involveLoading) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "1" }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "0" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "7. 是否涉及机器操作?",
                prop: "involveMachine",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(form).involveMachine,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).involveMachine) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "1" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "0" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "btn",
              onClick: submitForm
            }, _toDisplayString(isSubmitting.value ? '提交中...' : '提交问卷'), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (goBack()))
          }, "返回首页")
        ]))
  ]))
}
}

})